/*
 * @Author: “zhangjiahao04”
 * @Date: 2023-08-23 15:50:14
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-19 15:00:46
 * @FilePath: \pico-ow2c-fe\src\pages\outer\about\index.tsx
 * @Description: 关于我们——moreExting组件
 * @url:www.picoxr.com/cn/about
 */
import styles from "../../index.module.scss";
import React from "react";
import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';

const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

interface IProps {
  words: Record<string, string>;
  media: IMedia[]; // 媒体评价列表
}
interface IMedia {
  id: string;
  title: string; // 标题
  briefIntroduction: string; // 简介
}
const Media: React.FC<IProps> = ({ words, media }) => {

  return (
    <>
      {media && (
        <div className={styles["media-reviews-warp"]}>
          <div className={styles["media-reviews-slider"]}>
            <NoSSR>
              <CustomSwiper
                loop={true}
                spaceBetween={36}
                swiperWrapClass={styles['custom-swiper-wrap']}
                swiperSlideClass={styles["custom-swiper-slider"]}
                isHidePagination={false}>
                {media.map((data: IMedia) => (
                  <div key={data.id} className={styles['media-item']}>
                    <h2>{data.title}</h2>
                    <div className={styles["text"]}>{data.briefIntroduction}</div>
                  </div>
                ))}
              </CustomSwiper>
            </NoSSR>
          </div>
        </div>
      )}
    </>
  );
};

export default Media;
